export default "__VITE_ASSET__CnRy4X5M__"